import { Button, Grid, Stack, Typography } from '@mui/material';
import { GridRowSelectionModel } from '@mui/x-data-grid';
import React, { useEffect, useState } from 'react';

import reportTemplateDefaultList from '../../constants/reportTemplateDefaultList';
import useConfirm from '../../hooks/useConfirm';
import { ReportTemplate } from '../../validationSchemas/ReportTemplateSchema';
import ReportTemplateItem from './ReportTemplateItem';

interface ReportTemplateDefaultListProps {
  userName: string;
  duplicateReportTemplateList: (selectedTemplates: ReportTemplate[], confirmMessage: () => Promise<unknown>) => void;
}

function ReportTemplateDefaultList({ userName, duplicateReportTemplateList }: ReportTemplateDefaultListProps) {
  const [selectedReportTemplateIds, setSelectedReportTemplateIds] = useState<GridRowSelectionModel>([]);
  const [selectedReportTemplates, setSelectedReportTemplates] = useState<ReportTemplate[]>([]);

  const { windowDotConfirm: windowDotConfirmDuplicate } = useConfirm(
    `Are you sure you want to duplicate ${selectedReportTemplates
      .map((reportTemplate: ReportTemplate) => `"${reportTemplate?.reportName}"`)
      .join(', ')}?`
  );

  useEffect(() => {
    setSelectedReportTemplates(
      selectedReportTemplateIds.map(
        (selectedReportTemplateId) =>
          reportTemplateDefaultList?.find(
            ({ reportTemplate }: { reportTemplate: ReportTemplate }) =>
              reportTemplate.templateId === selectedReportTemplateId
          )?.reportTemplate
      )
    );
  }, [selectedReportTemplateIds]);

  const customStyle1 = {
    fontSize: '12px',
    color: '#616161',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '1.68px',
  };

  return (
    <Stack spacing={2}>
      <Stack direction="row">
        <Stack flex={1}>
          <Typography sx={customStyle1}>Default Templates</Typography>
        </Stack>
        <Stack flex={1} direction="row" spacing={1} justifyContent="end" width="100%">
          <Button
            variant="outlined"
            disabled={selectedReportTemplateIds?.length === 0}
            onClick={() => duplicateReportTemplateList(selectedReportTemplates, windowDotConfirmDuplicate)}
          >
            Clone
          </Button>
        </Stack>
      </Stack>
      <Stack>
        <Grid container spacing={2}>
          {reportTemplateDefaultList.map((item) => (
            <Grid item xs={3} key={item.reportTemplate.templateId}>
              <ReportTemplateItem
                reportTemplate={item.reportTemplate}
                ownerName={userName}
                selectedReportTemplateIds={selectedReportTemplateIds}
                setSelectedReportTemplateIds={setSelectedReportTemplateIds}
                defaultTemplate
              />
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Stack>
  );
}

export default ReportTemplateDefaultList;
